import ls from "localstorage-slim";

export function lsEncrypt(key, value) {
  ls.set(key, value, { encrypt: true });
}

export function lsDecrypt(key) {
  return ls.get(key, { decrypt: true });
}

// Function to get headers for HTTP requests
export const getHeader = (token, extraHeaders = {}) => {
  return {
    withCredentials: true,
    Authorization: `Bearer ${token}`,
    UserGroup: JSON.parse(localStorage.getItem("userGroup")),
    ...extraHeaders,
  };
};
